import type { GridSortModel } from "@mui/x-data-grid-premium";
import type { ReportField, SortConfiguration, SortField } from "../../../../../../../../api/types/svTypes.ts";
import { Ordering, SortType } from "../../../../../../../../api/types/svTypes.ts";

export const getSortModel = (sorts: SortField[]): GridSortModel => {
  return sorts.map((s) => ({
    field: s.config.id,
    sort: s.config.ordering === Ordering.Descending ? "desc" : "asc",
  }));
};

export const toSortConfigurations = (sortModel: GridSortModel, fields: ReportField[]): SortConfiguration[] => {
  return sortModel
    .map((item): SortConfiguration | undefined => {
      const field = fields.find((f) => f.config.guid === item.field);
      if (!field) {
        return undefined;
      }
      return {
        name: field.meta.name,
        id: field.config.guid,
        ordering: item.sort === "desc" ? Ordering.Descending : Ordering.Ascending,
        caption: field.config.customLabel || field.meta.caption,
        isGroupField: false,
        type: SortType.Dimension,
      };
    })
    .filter((s): s is SortConfiguration => !!s);
};
